import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {

  return (
    <Card className="card">
     <CardMedia
         component="img"
         src={product.image}
         alt={product.name}
         className="cardImage"
      />
      <CardContent>
        <Typography gutterBottom variant="h6" component="div" className="cardTitle">
          {product.name}
        </Typography>
        <Typography variant="body2" className="cardPrice">
        {/* <span>&#36;</span> */}
        $
        {product.cost}
        </Typography>
        <Rating name="read-only" value={product.rating} readOnly />
      </CardContent>
      <CardActions className="card-actions">
        <Button onClick={()=>handleAddToCart(product._id,1)} className="card-button" size="small" variant="contained"><AddShoppingCartOutlined style={{marginRight:"8px"}}/> Add to cart</Button>  
      </CardActions>
    </Card>
  );
};

export default ProductCard;
